import bidello,{component} from "bidello";
import {AbstractUI} from "./AbstractUI";
export class SlideSelector extends component(AbstractUI){

    init(){

        this.bindEvents()
    }

    bindEvents (){

        const slideSelectorChildren = [].slice.call(this.domElement.querySelectorAll('.slide-selector__item'))

    }



}
